import type { ValidationError, FieldValidationInput } from '../../../../types/validation.tsx';
import { POSITION_FIELD_DESCRIPTION_INPUT, POSITION_FIELD_NAME_INPUT } from '../../constants.tsx';
import { messages } from './messages.tsx';

const valid: ValidationError[] = [];
const errorFieldEmptyName: ValidationError[] = [
	{
		position: POSITION_FIELD_NAME_INPUT,
		messageDescriptor: messages.errorFieldEmptyName,
	},
];

export const nameMustBeNotEmpty = ({
	field,
	isValidationForced,
}: FieldValidationInput): ValidationError[] => {
	if (!isValidationForced) {
		// User may want to return to this field later, or they could be in the middle of typing
		return valid;
	}
	if (field.name === '') {
		return errorFieldEmptyName;
	}
	return valid;
};

export const descriptionMustNotBeLongerThan = (maximumDescriptionLength: number) => {
	const errorFieldDescriptionTooLong = [
		{
			position: POSITION_FIELD_DESCRIPTION_INPUT,
			messageDescriptor: messages.errorFieldDescriptionTooLong,
			values: {
				maxCharacters: maximumDescriptionLength,
			},
		},
	];
	return ({ field }: FieldValidationInput): ValidationError[] => {
		// Our types say that field.description is never null/undefined, but Sentry reports that in prod it sometimes is
		if (field.description != null && field.description.length > maximumDescriptionLength) {
			return errorFieldDescriptionTooLong;
		}
		return valid;
	};
};
